import { faqs } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { FaqAccordion } from "@/components/FaqAccordion";
import { CallButton } from "@/components/CallButton";
import { Reveal } from "@/components/Reveal";

export const FaqPreview = () => (
  <section
    className="border-y border-white/10 bg-ink-surface py-24 md:py-32"
    data-testid="faq-section"
  >
    <div className="mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <SectionHeader
            overline="Q & A"
            title="Questions, answered"
            description="Because every job is different, the best answers come from a quick phone call — but here are the essentials."
          />
          <div className="mt-8">
            <CallButton size="lg" showNumber testid="faq-call-btn" />
          </div>
        </div>
        <Reveal>
          <FaqAccordion items={faqs} />
        </Reveal>
      </div>
    </div>
  </section>
);
